import type { SeoData } from './types';

export const seoData: Record<'pl' | 'de', SeoData> = {
  pl: {
    logoAlt: "Prestige Care - profesjonalna opieka domowa w Niemczech",
    heroAlt: "Opiekunka wspierająca osobę starszą w domu",
    aboutAlt: "Wieloletnie doświadczenie w opiece nad seniorami",
    servicesAlt: "Zaufana współpraca i bezpieczna opieka 24/7",
    flagPlAlt: "Zmień język na polski",
    flagDeAlt: "Zmień język na niemiecki"
  },
  de: {
    logoAlt: "Prestige Care - professionelle häusliche Pflege in Deutschland",
    heroAlt: "Betreuungskraft unterstützt Senioren zu Hause",
    aboutAlt: "Langjährige Erfahrung in der Seniorenbetreuung",
    servicesAlt: "Zuverlässige Zusammenarbeit und sichere 24/7 Pflege",
    flagPlAlt: "Sprache auf Polnisch ändern",
    flagDeAlt: "Sprache auf Deutsch ändern"
  }
};